export default {
  EDITS_PAGE_LOADING: '@LOOKS_EDITS_PAGE_LOADING',
  EDITS_PAGE_SUCCESS: '@LOOKS_EDITS_PAGE_SUCCESS',
  CLEAR_EDITS_PAGE_SUCCESS: '@LOOKS_CLEAR_EDITS_PAGE_SUCCESS',
  EDITS_PAGE_ERROR: '@LOOKS_EDITS_PAGE_ERROR',

  EDITS_PAGE_UPDATE_SUCCESS: '@LOOKS_EDITS_PAGE_UPDATE_SUCCESS',
  EDITS_PAGE_UPDATE_ERROR: '@LOOKS_EDITS_PAGE_UPDATE_ERROR',
  EDITS_PAGE_UPDATE_STYLEBOARD_SUCCESS: '@LOOKS_EDITS_PAGE_UPDATE_STYLEBOARD_SUCCESS',

  EDITS_PAGE_SAVE_SUCCESS: '@LOOKS_EDITS_PAGE_SAVE_SUCCESS',
  EDITS_PAGE_SAVE_ERROR: '@LOOKS_EDITS_PAGE_SAVE_ERROR',
  EDITS_DELETE_SUCCESS: '@LOOKS_EDITS_DELETE_SUCCESS',
  EDITS_DELETE_ERROR: '@LOOKS_EDITS_DELETE_ERROR',

  EDIT_PRODUCT_DETAILS_LOADING: '@EDIT_PRODUCT_DETAILS_LOADING',
  EDIT_PRODUCT_DETAILS_SUCCESS: '@EDIT_PRODUCT_DETAILS_SUCCESS',
  EDIT_PRODUCT_DETAILS_ERROR: '@EDIT_PRODUCT_DETAILS_ERROR',
  EDIT_PRODUCT_DETAILS_SET_COLOR_SKU: '@EDIT_PRODUCT_DETAILS_SET_COLOR_SKU',
  EDIT_PRODUCT_DETAILS_CLEAR: '@EDIT_PRODUCT_DETAILS_CLEAR',
  EDIT_PRODUCT_DETAILS_PARTIAL_CLEAR: '@EDIT_PRODUCT_DETAILS_PARTIAL_CLEAR',
};
